import Vue from 'vue';
// eslint-disable-next-line import/extensions
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
import admin from './plugins/admin';
import AutocompleteInput from './components/base/AutocompleteInput.vue';
import './plugins/i18n';
import './plugins/base';
import './plugins/chartist';
import './sass/overrides.sass';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import Pro packs (note the 'pro' in the package name)
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'

// Add them all to the library
library.add(fas, far, fal, fad)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;
Vue.component('AutocompleteInput', AutocompleteInput);

new Vue({
  router,
  store,
  i18n,
  // eslint-disable-next-line
  // @ts-ignore
  vuetify,
  // eslint-disable-next-line
  // @ts-ignore
  admin,
  render: (h) => h(App),
}).$mount('#app');
